import { useState } from "react";

export default function Header({
  nse,
  nse_cash,
  options,
  mcx,
  mcx_options,
  sgx,
  crypto,
  comex,
  forex,
  index,
  us_stock,
  dgcx,
  ncdex,
  filter,
}) {
  const [selectValue, setSelectValue] = useState(null);

  const statCard = (label, select, onClick) => {
    return (
      <div
        onClick={() => {
          onClick(select);
          setSelectValue(select);
        }}
        className={select === selectValue ? buttonStyle : buttonStyleDe}
        style={{ marginLeft: 5 }}
      >
        {label}
      </div>
    );
  };
  const buttonStyle =
    "relative flex items-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 bg-[var(--primary)] border-2 text-white border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)] cursor-pointer";
  const buttonStyleDe =
    "relative flex items-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 border-2 border-[var(--hover)] text-[var(--text)] hover:border-[var(--primary)]  ";

  return (
    <header
      className="bg-[var(--background)]"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px",
        height: "60px",
      }}
    >
      {/* Left: (can add stats/info later) */}
      <div style={{ display: "flex", gap: "16px" }}>
        {nse === 1 && statCard("NSE-FUTURE", 0, filter)}
        {nse_cash === 1 && statCard("NSE-EQUITY", 1, filter)}
        {options === 1 && statCard("NSE-OPTIONS", 2, filter)}
        {mcx === 1 && statCard("MCX-FUTURE", 3, filter)}
        {mcx_options === 1 && statCard("MCX-OPTIONS", 4, filter)}
        {sgx === 1 && statCard("SGX", 5, filter)}
        {crypto === 1 && statCard("CRYPTO", 6, filter)}
        {comex === 1 && statCard("COMEX", 7, filter)}
        {forex === 1 && statCard("FOREX", 8, filter)}
        {us_stock === 1 && statCard("US-STOCK", 9, filter)}
        {index === 1 && statCard("INDEX", 10, filter)}
        {dgcx === 1 && statCard("DGCX", 11, filter)}
        {ncdex === 1 && statCard("NCDEX", 12, filter)}
      </div>
    </header>
  );
}
